module.exports = __webpack_public_path__ + "img/BoD_10_Ms_Teoh_Zsin_Woon.76aac9cb.jpg";